module.exports = __webpack_public_path__ + "assets/GB.5346c62901c7026f455a52b7324ef6c9.png";